import SlimSelect from "slim-select";

$(function() {
    let $select = document.querySelector('select'),
        $dropDown = $('.js-drop-down');

    if ($select) {
        $('select:not(.js-search-members-location-select)').each((i, e) => {
            new SlimSelect({
                select: e,
                showSearch: false
            })
        });
    }

    if ($dropDown && window.innerWidth < 641) {
        let $currentName = $('.js-drop-down-current-name'),
            $dropDownList = $('.js-drop-down-list'),
            $dropDownCurrentName = $dropDownList.find('a[aria-current="page"]').text();

        $currentName.text($dropDownCurrentName);

        $dropDown.on('click', function H() {
            let $this = $(this);

            if(!$this.hasClass('open')) {
                $this.addClass('open');
                $this.find('.js-drop-down-list')
                    .fadeIn(200);
            } else {
                $this.removeClass('open');
                $this.find('.js-drop-down-list').fadeOut(200);
            }
        });

        $('.js-drop-down-list > li').on('click', function H() {
            $currentName.text($(this).text());
        });
    }

});